export { EmailBanner } from './EmailBanner';
export type { EmailBannerProps, EmailBannerStatus } from './types';
